import cx from 'classnames';
import { counties } from 'mk/autogenerated/geoData';
import { PLACES } from 'mk/autogenerated/geoDataPlaces';
import {
    ADD_AVATAR,
    DO_NOT_WANT_TO_TELL,
    HOME_SIGNUP_BAZAAR,
    HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link,
    HOME_SIGNUP_IF_REGISTERED_LOGIN_HERE_link,
    HOME_SIGNUP_LOGIN_HERE,
    HOME_SIGNUP_PRIVACY,
    HOME_SIGNUP_VOP,
    PHONE_VERIFICATION_ANSWER,
    PHONE_VERIFICATION_QUESTION,
    PHONE_VERIFICATION_SEND_SMS_EXPLANATION_FREE,
    PHONE_VERIFICATION_VERIFY_SMS_CHANGE_BTN,
    PHONE_VERIFICATION_VERIFY_SMS_SMS_TOKEN_LABEL,
    PREGNANCY_STATE,
    PREGNANT,
    SETTINGS_I_LIVE_ABROAD,
    SIGN_UP_AND_HAVE_PROFIT_IT_TAKES_ONLY_ONE_MINUTE_AND_IS_FREE,
    SIGNUP_BUTTON,
    SIGNUP_CONFIRM_AND_SIGN_UP,
    SIGNUP_DOES_PHOTO_FOLLOW_RULES,
    SIGNUP_DUE_DATE,
    SIGNUP_EMAIL,
    SIGNUP_I_DONT_WANT_UPLOAD_PHOTO,
    SIGNUP_I_HAVE_FOREIGN_PHONE_NUMBER,
    SIGNUP_I_HAVE_LOCAL_PHONE_NUMBER,
    SIGNUP_ITS_MY_CURRENT_PHOTO,
    SIGNUP_LOCATION_COUNTRY,
    SIGNUP_LOCATION_COUNTY,
    SIGNUP_LOCATION_PLACE,
    SIGNUP_MY_FACE_IS_CLEARLY_VISIBLE,
    SIGNUP_NEXT_STEP,
    SIGNUP_ON_number_change_WE_SENT_YOU_SMS,
    SIGNUP_ON_PICTURE_I_AM_ALONE_OR_WITH_CHILD,
    SIGNUP_PASSWORD,
    SIGNUP_PHONE_COUNTRY_PREFIX,
    SIGNUP_PHOTO_RULES_btn,
    SIGNUP_REASON_TO_UPLOAD_PHOTO,
    SIGNUP_SEND_ME_CODE,
    SIGNUP_TOKEN_NOT_RECEIVED_RESEND,
    SIGNUP_TOKEN_VERIFICATION_EXPLANATION_price,
    SIGNUP_USERNAME,
    SIGNUP_VERIFY_TOKEN,
    SIGNUP_WE_SENT_YOU_ACTIVATION_CODE,
    SIGNUP_WE_WILL_SEND_YOU_TOKEN,
    SIGNUP_WHICH_PHOTO_TO_ADD,
    SIGNUP_WOULD_YOU_LIKE_TO_UPLOAD_PHOTO,
    SIGNUP_YOUR_LOCAL_PHONE_NUMBER,
    SIGNUP_YOUR_MOBILE_NUMBER,
    WE_ARE_TRYING_TO_CONCEIVE,
    WE_HAVE_CHILDREN,
} from 'mk/autogenerated/translations/SignupForm.1be23a6bf5580d82daa32175ded55b14'
import assetUrl from 'mk/common/assetUrl';
import { about_privacy_url, about_rules_bazaar_url, about_rules_common_url } from 'mk/urls/functions';
import { UtmQuery } from 'mk2/apps/home/schemas';
import { PregnancyState } from 'mk2/apps/settings/schemas';
import SignupProgressBar from 'mk2/apps/users/components/SignupProgressBar';
import { VALIDATE_REGISTRATION_INPUTS_TRIGGER } from 'mk2/apps/users/containers/Signup/Signup.actions';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/containers/Signup/Signup.constants';
import { loginUrl } from 'mk2/apps/users/urls';
import { cleanPhoneNumber } from 'mk2/apps/users/utils';
import Btn, { BtnSidePadding, BtnType } from 'mk2/components/Btn';
import DateSelectField from 'mk2/components/forms/DateSelectField';
import InputField from 'mk2/components/forms/InputField';
import PasswordField from 'mk2/components/forms/PasswordField';
import PhotoCropField from 'mk2/components/forms/PhotoCropField';
import PhotosFieldNew from 'mk2/components/forms/PhotosFieldNew';
import SelectField, { Option } from 'mk2/components/forms/SelectField';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import Img from 'mk2/components/Img';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import { FormPageType } from 'mk2/constants';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import ActionButton from 'mk2/containers/ActionButton/ActionButton';
import {
    PHONE_VERIFICATION_SAVE_TOKEN_REQUEST,
    PHONE_VERIFICATION_SEND_SMS_REQUEST,
} from 'mk2/containers/PhoneVerification/PhoneVerification.actions';
import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import { prefixesOptions } from 'mk2/containers/PhoneVerification/SendSmsTokenStep';
import { prettyNumber } from 'mk2/containers/PhoneVerification/VerifySmsTokenStep';
import { PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { isSuccess } from 'mk2/reducers/loadingState';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './SignupForm.mscss';

interface OwnProps {
    simple: boolean;
    iframe: boolean;
    query: UtmQuery;
    divRef?: React.RefObject<HTMLDivElement>;
    initialValues: SignupFormData;
    currentValues: SignupFormData;
    signupVariant?: ABState;
    avatar?: PhotoEntity;
    onLoadAB?();
    onStoreEvent(name: string, props: any);
    onSignup(values: SignupFormData);
    onValidateInputs?(values: SignupFormData);
    onSendSmsToken?(prefix: string, phoneNumber: string, mode: Mode);
    onVerifySmsToken(token: string, mode: Mode, fullPhoneNumber: string);
    onPrepareUploadPhotos(formName: string, config: PhotosUploadConfig, files: File[], processPhotoUploadOnFormPage: FormPageType, accessKey?: string);
}

interface OwnState {
    showDueDate: boolean;
    countyId: number;
    foreignNumber: boolean;
    crop: any;
}

export interface SignupFormData {
    username: string;
    password: string;
    email: string;
    locationCounty?: string;
    place?: string;
    pregnancyState?: string;
    dueDate?: string;
    prefix: string;
    phoneNumber: string;
    token: string;
    photos: any;
    currentPhoto: boolean;
    visibleFace: boolean;
    alonePhoto: boolean;
    avatarCrop: any;
}

const photosConfig: PhotosUploadConfig = {
    photoType: 'avatar',
    multiple: false,
    showPhotoCode: false,
};

type Props = OwnProps;

const PREGNANCY_STATE_CHOICES: Option[] = [
    { value: null, label: '', isPlaceholder: true },
    { value: PregnancyState.Pregnant, label: PREGNANT },
    { value: PregnancyState.Trying, label: WE_ARE_TRYING_TO_CONCEIVE },
    { value: PregnancyState.HasChildren, label: WE_HAVE_CHILDREN },
    { value: PregnancyState.DoNotTell, label: DO_NOT_WANT_TO_TELL },
];

class SignupFormComponent extends React.Component<Props & MKReduxFormInjectedProps<SignupFormData, Props>, OwnState> {
    public state: OwnState = {
        showDueDate: false,
        countyId: -1,
        foreignNumber: false,
        crop: {
            width: 100,
            aspect: 1,
        },
    };

    private photosFieldRef: PhotosFieldNew;

    public componentWillMount() {
        this.load();
    }

    public componentDidMount() {
        const { onStoreEvent, query } = this.props;
        onStoreEvent('signup_visited', {
            utm_campaign: query.utm_campaign
                ? query.utm_campaign
                : query.mkutm_campaign
                    ? query.mkutm_campaign
                    : null,
            utm_medium: query.utm_medium
                ? query.utm_medium
                : query.mkutm_medium
                    ? query.mkutm_medium
                    : null,
            utm_source: query.utm_source
                ? query.utm_source
                : query.mkutm_source
                    ? query.mkutm_source
                    : null,
            utm_content: query.utm_content
                ? query.utm_content
                : query.mkutm_content
                    ? query.mkutm_content
                    : null,
        });
    }

    public render() {
        const {currentFormPage, signupVariant, iframe} = this.props;
        if (!iframe && signupVariant && signupVariant.variant === 'newsignup') {
            if (currentFormPage === FormPageType.SignupPhotoUpload) {
                return this.renderPhotoUpload();
            } else if (currentFormPage === FormPageType.SignupTokenValidation) {
                return this.renderTokenValidation();
            } else if (currentFormPage === FormPageType.SignupPhoneVerification) {
                return this.renderPhoneVerification();
            } else {
                return this.renderMain();
            }
        } else {
            return this.renderOldSignup();
        }

    }

    public renderMain() {
        const { simple, iframe, handleSubmit, currentFormPage } = this.props;

        return (
            <>
                <div
                    ref={this.props.divRef}
                    className={cx(styles.SignupForm, currentFormPage === FormPageType.Main && styles[`SignupForm--mainPage`])}
                >
                    <div>
                        <form className={styles.SignupForm__form} onSubmit={handleSubmit}>
                            <InputField
                                name="username"
                                type="text"
                                label={SIGNUP_USERNAME}
                                transparent={iframe}
                                autoComplete="new-password"
                            />
                            <PasswordField
                                name="password"
                                label={SIGNUP_PASSWORD}
                                transparent={iframe}
                                autoComplete="new-password"
                            />
                            <InputField
                                name="email"
                                type="text"
                                label={SIGNUP_EMAIL}
                                transparent={iframe}
                            />
                            {!simple && (
                                <>
                                    <SelectField
                                        name="locationCounty"
                                        label={SIGNUP_LOCATION_COUNTY}
                                        options={this.countiesOptions()}
                                        onChange={this.handleSelectCounty}
                                        transparent={iframe}
                                    />
                                    {this.state.countyId >= 0 ? (
                                        <SelectField
                                            name="place"
                                            options={this.placesOptions()}
                                            label={
                                                this.state.countyId > 0
                                                    ? SIGNUP_LOCATION_PLACE
                                                    : SIGNUP_LOCATION_COUNTRY
                                            }
                                            transparent={iframe}
                                        />
                                    ) : null}
                                    <SelectField
                                        name="pregnancyState"
                                        label={PREGNANCY_STATE}
                                        options={PREGNANCY_STATE_CHOICES}
                                        onChange={this.handlePregnancyStateChange}
                                        transparent={iframe}
                                    />
                                    {this.state.showDueDate && (
                                        <DateSelectField
                                            name="dueDate"
                                            label={SIGNUP_DUE_DATE}
                                            yearFrom={new Date().getFullYear()}
                                            yearTo={
                                                new Date().getMonth() > 3
                                                    ? new Date().getFullYear() + 1
                                                    : new Date().getFullYear()
                                            }
                                            transparent={iframe}
                                        />
                                    )}
                                </>
                            )}
                            <ActionButton
                                className={styles.SignupForm__button}
                                label={SIGNUP_NEXT_STEP}
                                triggerAction={VALIDATE_REGISTRATION_INPUTS_TRIGGER}
                                onClick={this.handleOnNextStep(FormPageType.SignupPhoneVerification)}
                                showSpinnerWhenBusy
                            />
                        </form>

                        <p className={styles.SignupForm__signin}>
                            <Interpolate
                                i18nKey={HOME_SIGNUP_IF_REGISTERED_LOGIN_HERE_link}
                                link={<Link to={loginUrl}>{HOME_SIGNUP_LOGIN_HERE}</Link>}
                            />
                        </p>
                    </div>
                    <div className={styles.SignupForm__textWrapper}>
                        <p className={styles.SignupForm__secondaryText}>
                            <Interpolate
                                i18nKey={
                                    HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link
                                }
                                bazaar_link={<a href={about_rules_bazaar_url()}>{HOME_SIGNUP_BAZAAR}</a>}
                                privacy_link={<a href={about_privacy_url()}>{HOME_SIGNUP_PRIVACY}</a>}
                                common_link={<a href={about_rules_common_url()}>{HOME_SIGNUP_VOP}</a>}
                            />
                        </p>
                    </div>
                </div>
            </>
        );
    }

    public renderPhoneVerification() {
        const { iframe } = this.props;

        return(
            <div ref={this.props.divRef} className={styles.SignupForm}>
                <div>
                    <div className={styles.SignupForm__svgWrapper}>
                        <SignupProgressBar lastCircleActive={false} />
                    </div>
                    <div className={styles.SignupForm__textWrapper}>
                        <h1 className={styles.SignupForm__title}> {SIGNUP_WE_WILL_SEND_YOU_TOKEN}</h1>
                        <p className={styles.SignupForm__text}>
                            <Interpolate
                                i18nKey={SIGNUP_TOKEN_VERIFICATION_EXPLANATION_price}
                                price={<strong>{PHONE_VERIFICATION_SEND_SMS_EXPLANATION_FREE}</strong>}
                            />
                        </p>
                    </div>
                    {this.state.foreignNumber &&
                        <SelectField
                            name="prefix"
                            label={SIGNUP_PHONE_COUNTRY_PREFIX}
                            options={prefixesOptions}
                            onChange={this.handleSelectCounty}
                            transparent={iframe}
                        />
                    }
                    <InputField
                        name="phoneNumber"
                        type="text"
                        label={!this.state.foreignNumber ? SIGNUP_YOUR_LOCAL_PHONE_NUMBER : SIGNUP_YOUR_MOBILE_NUMBER}
                        transparent={iframe}
                    />
                    <div className={styles.SignupForm__phoneActions}>
                        <ActionButton
                            key="send-token-btn"
                            type={BtnType.Blue}
                            label={SIGNUP_SEND_ME_CODE}
                            onClick={this.handleOnNextStep(FormPageType.SignupTokenValidation)}
                            triggerAction={PHONE_VERIFICATION_SEND_SMS_REQUEST}
                            showSpinnerWhenBusy
                        />
                        <Btn
                            key="foreign-number-btn"
                            onClick={this.onForeignNumberClick}
                            label={!this.state.foreignNumber ? SIGNUP_I_HAVE_FOREIGN_PHONE_NUMBER : SIGNUP_I_HAVE_LOCAL_PHONE_NUMBER}
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{
                                label: styles.SignupForm__secondaryBtn,
                            }}
                        />
                    </div>
                </div>
                <div className={cx(styles.SignupForm__textWrapper, styles.SignupForm__bottomText)}>
                    <h3 className={styles.SignupForm__secondaryTitle}>
                        {PHONE_VERIFICATION_QUESTION}
                    </h3>
                    <p className={styles.SignupForm__secondaryText}>
                        {PHONE_VERIFICATION_ANSWER}
                    </p>
                </div>
            </div>
        );
    }

    public renderTokenValidation() {
        const { iframe, currentValues } = this.props;

        return(
            <div ref={this.props.divRef} className={styles.SignupForm}>
                <div>
                    <div className={styles.SignupForm__svgWrapper}>
                        <SignupProgressBar lastCircleActive={false} />
                    </div>
                    <div className={styles.SignupForm__textWrapper}>
                        <h1 className={styles.SignupForm__title}>{SIGNUP_WE_SENT_YOU_ACTIVATION_CODE}</h1>
                        <Interpolate
                            i18nKey={SIGNUP_ON_number_change_WE_SENT_YOU_SMS}
                            number={(
                                <strong>
                                    {prettyNumber(currentValues.prefix + cleanPhoneNumber(currentValues.prefix, currentValues.phoneNumber))}
                                </strong>
                            )}
                            change={
                                <Btn
                                    label={PHONE_VERIFICATION_VERIFY_SMS_CHANGE_BTN}
                                    onClick={this.handleOnNextStep(FormPageType.SignupPhoneVerification)}
                                    sidePadding={BtnSidePadding.None}
                                    type={BtnType.BlueTextLight}
                                />
                            }
                        />
                    </div>
                    <InputField
                        name="token"
                        type="text"
                        label={PHONE_VERIFICATION_VERIFY_SMS_SMS_TOKEN_LABEL}
                        transparent={iframe}
                    />
                    <div className={styles.SignupForm__phoneActions}>
                        <ActionButton
                            type={BtnType.Blue}
                            label={SIGNUP_VERIFY_TOKEN}
                            onClick={this.handleOnNextStep(FormPageType.SignupPhotoUpload)}
                            triggerAction={PHONE_VERIFICATION_SAVE_TOKEN_REQUEST}
                            showSpinnerWhenBusy
                        />
                        <Btn
                            onClick={this.handleSendSmsToken}
                            label={SIGNUP_TOKEN_NOT_RECEIVED_RESEND}
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{
                                label: styles.SignupForm__secondaryBtn,
                            }}
                        />
                    </div>
                </div>
                <div className={cx(styles.SignupForm__textWrapper, styles.SignupForm__bottomText)}>
                    <h3 className={styles.SignupForm__secondaryTitle}>
                        {PHONE_VERIFICATION_QUESTION}
                    </h3>
                    <p className={styles.SignupForm__secondaryText}>
                        {PHONE_VERIFICATION_ANSWER}
                    </p>
                </div>
            </div>
        );
    }

    public renderPhotoUpload() {
        const { avatar, mobile } = this.props;
        return(
            <div ref={this.props.divRef} className={styles.SignupForm}>
                <div className={styles.SignupForm__svgWrapper}>
                    <SignupProgressBar lastCircleActive/>
                </div>
                {!avatar && (
                    <div key="photo-upload-content">
                        <div className={styles.SignupForm__textWrapper}>
                            <h1 className={styles.SignupForm__title}>{SIGNUP_WOULD_YOU_LIKE_TO_UPLOAD_PHOTO}</h1>
                            <p className={styles.SignupForm__text}>
                                <Interpolate
                                    i18nKey={SIGNUP_REASON_TO_UPLOAD_PHOTO}
                                    useDangerouslySetInnerHTML
                                />
                            </p>
                        </div>
                        <div className={styles.SignupForm__uploadAvatar}>
                            <Img
                                className={styles.ProfileForm__avatarField__img}
                                src={assetUrl + 'img/avatars/user/no_photo_150_1.png'}
                                width={100}
                                height={100}
                            />
                            {/*this has to be always rendered, so that <input type="file"> is in dom*/}
                            {/*and we can call it's click() to show file open dialog*/}
                            <PhotosFieldNew
                                key="photos"
                                name="photos"
                                config={photosConfig}
                                ref={this.handlePhotosFileInputFieldRef}
                                onUploadFiles={this.handleUploadFiles}
                            />
                            <Btn
                                type={BtnType.Blue}
                                label={ADD_AVATAR}
                                icon="fa-camera"
                                onClick={this.handleOpenFileExplorer}
                                className={styles.SignupForm__uploadAvatarBtn}
                            />
                            <SubmitButton
                                label={SIGNUP_I_DONT_WANT_UPLOAD_PHOTO}
                                formName={SIGNUP_FORM_NAME}
                                btnType={BtnType.BlueText}
                                disableIfNotDirty={false}
                                className={styles.SignupForm__submitWithoutPhoto}
                            />
                        </div>
                    </div>
                )}

                {avatar && (
                    <>
                        <div className={styles.SignupForm__cropWrapper}>
                            <PhotoCropField
                                name="avatarCrop"
                                photo={avatar}
                                marginLeft={false}
                                bottomBorder={false}
                            />
                        </div>
                        <div className={styles.SignupForm__textWrapper}>
                            <h3 className={cx(styles.SignupForm__title, styles.SignupForm__photoRulesTitle)}>{SIGNUP_DOES_PHOTO_FOLLOW_RULES}</h3>
                        </div>
                        <ul className={styles.SignupForm__photoRules}>
                            <li>{SIGNUP_ITS_MY_CURRENT_PHOTO}</li>
                            <li>{SIGNUP_MY_FACE_IS_CLEARLY_VISIBLE}</li>
                            <li>{SIGNUP_ON_PICTURE_I_AM_ALONE_OR_WITH_CHILD}</li>
                        </ul>
                    </>
                )}

                {!avatar && (
                    <div className={cx(styles.SignupForm__textWrapper, styles.SignupForm__bottomText)} key="additional-text">
                        <h3 className={styles.SignupForm__secondaryTitle}>{SIGNUP_WHICH_PHOTO_TO_ADD}</h3>
                        <p className={styles.SignupForm__secondaryText}>
                            <Interpolate
                                i18nKey={SIGNUP_PHOTO_RULES_btn}
                                btn={<a href={about_rules_common_url()}>{HOME_SIGNUP_VOP}</a>}
                            />
                        </p>
                    </div>
                )}
                {avatar && !mobile &&
                    <SubmitButton
                        className={styles.SignupForm__submitBtn}
                        label={SIGNUP_CONFIRM_AND_SIGN_UP}
                        formName={SIGNUP_FORM_NAME}
                    />
                }
            </div>
        );
    }

    public renderOldSignup() {
        const { simple, iframe, handleSubmit } = this.props;

        return (
            <div
                ref={this.props.divRef}
                className={cx(styles.OldSignupForm, iframe && styles[`OldSignupForm--iframe`])}
            >
                {!iframe && (
                    <div
                        className={styles.OldSignupForm__cta}
                        dangerouslySetInnerHTML={{
                            __html: SIGN_UP_AND_HAVE_PROFIT_IT_TAKES_ONLY_ONE_MINUTE_AND_IS_FREE,
                        }}
                    />
                )}
                <form className={styles.OldSignupForm__form} onSubmit={handleSubmit}>
                    <InputField
                        name="username"
                        type="text"
                        label={SIGNUP_USERNAME}
                        marginLeft={false}
                        transparent={iframe}
                        autoComplete="new-password"
                    />
                    <PasswordField
                        name="password"
                        label={SIGNUP_PASSWORD}
                        marginLeft={false}
                        transparent={iframe}
                        autoComplete="new-password"
                    />
                    <InputField
                        name="email"
                        type="text"
                        label={SIGNUP_EMAIL}
                        marginLeft={false}
                        transparent={iframe}
                    />
                    {!simple && (
                        <>
                            <SelectField
                                name="locationCounty"
                                label={SIGNUP_LOCATION_COUNTY}
                                options={this.countiesOptions()}
                                marginLeft={false}
                                onChange={this.handleSelectCounty}
                                transparent={iframe}
                            />
                            {this.state.countyId >= 0 ? (
                                <SelectField
                                    name="place"
                                    options={this.placesOptions()}
                                    label={
                                        this.state.countyId > 0
                                            ? SIGNUP_LOCATION_PLACE
                                            : SIGNUP_LOCATION_COUNTRY
                                    }
                                    marginLeft={false}
                                    transparent={iframe}
                                />
                            ) : null}
                            <SelectField
                                name="pregnancyState"
                                label={PREGNANCY_STATE}
                                options={PREGNANCY_STATE_CHOICES}
                                marginLeft={false}
                                onChange={this.handlePregnancyStateChange}
                                transparent={iframe}
                            />
                            {this.state.showDueDate && (
                                <DateSelectField
                                    name="dueDate"
                                    label={SIGNUP_DUE_DATE}
                                    marginLeft={false}
                                    yearFrom={new Date().getFullYear()}
                                    yearTo={
                                        new Date().getMonth() > 3
                                            ? new Date().getFullYear() + 1
                                            : new Date().getFullYear()
                                    }
                                    transparent={iframe}
                                />
                            )}
                        </>
                    )}
                    <SubmitButton
                        className={styles.OldSignupForm__button}
                        formName={SIGNUP_FORM_NAME}
                        label={SIGNUP_BUTTON}
                        disableIfNotDirty={false}
                    />
                </form>

                <p className={styles.OldSignupForm__legal}>
                    <Interpolate
                        i18nKey={
                            HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link
                        }
                        bazaar_link={<a href={about_rules_bazaar_url()}>{HOME_SIGNUP_BAZAAR}</a>}
                        privacy_link={<a href={about_privacy_url()}>{HOME_SIGNUP_PRIVACY}</a>}
                        common_link={<a href={about_rules_common_url()}>{HOME_SIGNUP_VOP}</a>}
                    />
                </p>
                <p className={styles.OldSignupForm__signin}>
                    <Interpolate
                        i18nKey={HOME_SIGNUP_IF_REGISTERED_LOGIN_HERE_link}
                        link={<Link to={loginUrl}>{HOME_SIGNUP_LOGIN_HERE}</Link>}
                    />
                </p>
            </div>
        );
    }

    private load = () => {
        const { signupVariant, onLoadAB, iframe } = this.props;
        if (signupVariant && !isSuccess(signupVariant.loadingState) && !iframe) {
            onLoadAB();
        }
    };

    private handlePhotosFileInputFieldRef = (ref: PhotosFieldNew) => {
        this.photosFieldRef = ref;
    };

    private handleOpenFileExplorer = () => {
        this.photosFieldRef.openFileExplorer();
    };

    private handleUploadFiles = (config: PhotosUploadConfig, files: File[]) => {
        const { onPrepareUploadPhotos } = this.props;
        onPrepareUploadPhotos(SIGNUP_FORM_NAME, config, files, FormPageType.SignupPhotoUpload);
    };

    private handleSendSmsToken = () => {
        const { onSendSmsToken, currentValues } = this.props;
        onSendSmsToken(currentValues.prefix, currentValues.phoneNumber, 'signup-no-user');
    };

    private onForeignNumberClick = () => {
        this.setState({foreignNumber: !this.state.foreignNumber});
    };

    private handleOnNextStep = (nextSignupStep) => {
        return () => {
            const { onValidateInputs, currentValues, onSendSmsToken, onVerifySmsToken } = this.props;
            if (nextSignupStep === FormPageType.SignupPhoneVerification) {
                onValidateInputs(currentValues);
            } else if (nextSignupStep === FormPageType.SignupTokenValidation) {
                onSendSmsToken(currentValues.prefix, currentValues.phoneNumber, 'signup-no-user');
            } else if (nextSignupStep === FormPageType.SignupPhotoUpload) {
                onVerifySmsToken(currentValues.token, 'signup-no-user', currentValues.prefix + cleanPhoneNumber(currentValues.prefix, currentValues.phoneNumber));
            }
        };
    };

    private handleSelectCounty = (event) => {
        this.setState({ countyId: parseInt(event.currentTarget.value, 10) });
    };

    private handlePregnancyStateChange = (event) => {
        if (event.currentTarget.value === '1') {
            this.setState({ showDueDate: true });
        } else {
            this.setState({ showDueDate: false });
        }
    };

    private countiesOptions = () => {
    return [{ value: '', label: '', isPlaceholder: true }]
        .concat(
            counties.map((county) => {
                return {
                    value: county[0].toString(),
                    label: county[1],
                    isPlaceholder: false,
                };
            }),
        )
        .concat({ value: '0', label: SETTINGS_I_LIVE_ABROAD, isPlaceholder: false });
    };

    private placesOptions = () => {
        return [{ value: '', label: '', isPlaceholder: true }].concat(
            PLACES.filter((place) => place[2] === this.state.countyId).map((p) => {
                return { value: p[0].toString(), label: p[1], isPlaceholder: false };
            }),
        );
    };
}

export const SignupForm = mkReduxFormNew<SignupFormData, Props>({
    formName: SIGNUP_FORM_NAME,
    onValidate: () => ({
        /* nothing to do */
    }),
    onSave: (values, props) => props.onSignup(values),
    disableDirtyCheck: true,
})(SignupFormComponent);
